import {
  useProcessCreationLoadingStore,
  processSocket,
  useProcessSocketStore,
  useAutoTranslation,
} from "@/entities"
import {
  ALLOWED_IMAGE_EXTENSIONS,
  ALLOWED_IMAGE_MIME_TYPES,
  DISCOVERED_TRANSLATION_KEYS,
} from "@/shared/constants"
import { uploadBrowserContent } from "@/shared/api/content-upload"
import { isSupportedImageFile } from "@/shared/utils"

import { toast } from "sonner"

const createTriggerInput = () => {
  const input = document.createElement("input")
  input.type = "file"
  input.accept = [
    ...ALLOWED_IMAGE_MIME_TYPES,
    ...ALLOWED_IMAGE_EXTENSIONS.map(extension => `.${extension}`),
  ].join(",")
  input.multiple = true
  input.click()
  return input
}

export function useCreateNoteImages() {
  const { t } = useAutoTranslation()
  const handleImagesUpload = async () => {
    const input = createTriggerInput()

    input.onchange = async e => {
      input.remove()
      const files = (e.target as HTMLInputElement).files
      if (!files || files.length === 0) return
      handleProcessImages(files)
    }
  }

  const handleProcessImages = async (files: FileList | File[]) => {
    if (!files || files.length === 0) return

    useProcessCreationLoadingStore.getState().startAppLoading()

    const validFiles: File[] = []
    for (const file of Array.from(files)) {
      if (!isSupportedImageFile(file)) {
        toast.error(t(DISCOVERED_TRANSLATION_KEYS.FILE_TYPE_NOT_SUPPORTED))
        continue
      }

      validFiles.push(file)
    }
    if (!validFiles.length) {
      useProcessCreationLoadingStore.getState().closeAppLoading()
      return
    }
    try {
      await useProcessSocketStore.getState().connectToProcessSocket()
      await uploadBrowserContent({
        kind: "PHOTOS",
        files: validFiles,
        socketClientId: processSocket.id,
      })
    } catch (error) {
      useProcessCreationLoadingStore.getState().closeAppLoading()
      toast.error(error instanceof Error ? error.message : "Upload failed")
    }
  }

  return { handleImagesUpload, handleProcessImages }
}
